import React from 'react';
import { useStore, Title, useGetIdentity } from 'react-admin';
import { Container, Typography } from '@mui/material';
import type { Partner } from '@src/types';

const WelcomeView = () => {
  const [currentPartner] = useStore<Partner | null>('currentPartner', null);
  const { data: identity } = useGetIdentity();

  const selectedPartnerName = currentPartner ?
    (currentPartner.name || currentPartner.displayName || `Partner ${currentPartner.id}`) :
    'No partner selected';

  const welcomeMessage = identity?.firstName ?
    `Welcome ${identity.firstName}` :
    'Welcome to the Trove Dashboard';

  return (
    <Container maxWidth={false}>
      <Title title={welcomeMessage} />
      <Typography variant="h4" align="center" gutterBottom sx={{
        marginTop: '3rem',
        fontWeight: 'bold'
      }}>
        Welcome to the Trove Dashboard
      </Typography>
      <Typography variant="body1" align="center">
        Use the navigation menu to access tools for
        {' '}
        <Typography component="span" fontWeight="bold">
          {selectedPartnerName}
        </Typography>
      </Typography>
    </Container>
  );
};

export default WelcomeView;
